import { Navigate, Outlet } from "react-router-dom";
import {getToken} from '../authorization/auth'

const IsAuth = () => {
    let token = getToken()
    if (!token) return (<Outlet />)
    return <Navigate to="/" replace />;
}

export default IsAuth;
